"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMultiplexer = void 0;
const react_1 = require("react");
const sdk_core_1 = require("@streem/sdk-core");
const rxjs_1 = require("./rxjs");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
function useMultiplexer(roomSession, videoController, container) {
    // TODO https://streempro.atlassian.net/browse/STREEM-8225
    // Camera switching will involve handling using different compositors
    // We should create something similar to Go's Context package to
    // signal the compositor to pause while we create a new compositor.
    const [cameraSubject] = (0, rxjs_1.useObservable)(videoController.cameraSubject);
    const [connected] = (0, rxjs_1.useObservable)(videoController.connected);
    const [canvasDims, setCanvasDims] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        let multiplexer = undefined;
        if ((container === null || container === void 0 ? void 0 : container.current) && connected) {
            multiplexer = new sdk_core_1.Multiplexer({
                roomSession,
                container: container.current,
                videoStarter: videoController,
                cameraSubject: cameraSubject !== null && cameraSubject !== void 0 ? cameraSubject : streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_PERSON,
                isLocalVideo: videoController.ownerIsLocalUser,
            });
            multiplexer.start();
        }
        const canvasDimensionsSubscription = multiplexer === null || multiplexer === void 0 ? void 0 : multiplexer.canvasDimensions.subscribe({
            next: dims => {
                setCanvasDims(dims);
            },
            error: err => console.error('Error with canvas dimensions: ', err),
        });
        return () => {
            if (multiplexer) {
                multiplexer.stop();
            }
            if (canvasDimensionsSubscription) {
                canvasDimensionsSubscription.unsubscribe();
            }
        };
    }, [roomSession, container, videoController, cameraSubject, connected]);
    return canvasDims;
}
exports.useMultiplexer = useMultiplexer;
//# sourceMappingURL=use_multiplexer.js.map